:host {
    width: 100%;
}

.content {
    display: flex;
    flex-grow: 1;
    height: calc(100% - 48px);
}

.trial-content {
    width: calc(100% - 68px);
    display: flex;
    flex-direction: column;

    &.expanded {
        width: calc(100% - 300px);
    }

    &.focus-mode {
        width: 100%;
    }
}

.notifications {
    margin-right: $pad-s;
}

.with-help {
    margin-left: $pad-s;
}

.tenant-picker-label {
    margin-left: $pad-xl;
    font-weight: $font-weight-semibold;
    font-size: $font-m-size;
    color: var(--color-foreground);
    line-height: $font-m-line-height;
}

.tenant-picker-dropdown {
    margin-left: $pad-s;
}

.enterprise-trial {
    display: flex;
    align-items: center;
}
